import { createContext } from 'react';

const GlobalEditContext = createContext([false]);

export { GlobalEditContext };
